module.exports = __webpack_public_path__ + "static/slide-2-c52c8f4bc23942a60ea97a6ecfc900b7.png";